import { createContext, useContext } from "react";

const OrgChartContext = createContext();

export default OrgChartContext;

export const useOrgChartContext = () => useContext(OrgChartContext);
